<template>
    <v-container
        id="ticket-alerts"
        class="d-flex flex-column flex-nowrap"
    >
        <v-row class="shrink">
            <v-toolbar
                id="top-alerts-toolbar"
                dense
                flat
            >
                <v-btn
                    icon
                    @click="$router.go(-1)"
                >
                    <v-icon class="material-icons-outlined">
                        chevron_left
                    </v-icon>
                </v-btn>
                <v-toolbar-title>Alerts</v-toolbar-title>
                <v-spacer />
                <router-link
                    to="/profile/alert-preferences"
                    style="text-decoration: none"
                >
                    <v-btn icon>
                        <v-icon class="material-icons-outlined">
                            settings
                        </v-icon>
                    </v-btn>
                </router-link>
            </v-toolbar>
        </v-row>
        <v-row
            class="shrink"
        >
            <v-toolbar flat>
                <span v-if="ticketAlerts.length">
                    {{ ticketAlerts.length }} Alerts
                </span>
                <v-spacer />
                <v-btn
                    v-if="!this.$vuetify.breakpoint.xsOnly"
                    color="#122448"
                    dark
                    elevation="0"
                    @click="dismissAllAlerts"
                >
                    Dismiss All
                </v-btn>
            </v-toolbar>
        </v-row>
        <v-row
            v-if="ticketAlerts.length"
            class="grow"
        >
            <div
                v-if="this.$vuetify.breakpoint.xsOnly"
                class="moblie-alert-container"
            >
                <v-data-iterator
                    :items="ticketAlerts"
                    loading-text="Loading items..."
                    hide-default-footer
                >
                    <template v-slot:default="props">
                        <v-flex
                            v-for="item in props.items"
                            :key="item.rowid"
                            xs12
                        >
                            <v-card
                                flat
                                tile
                                class="mobile-alert-card"
                            >
                                <div class="mobile-alert-dismiss-Icon">
                                    <v-icon
                                        class="mr-2"
                                        @click="dismissAlert(item.rowid)"
                                    >
                                        close
                                    </v-icon>                                    
                                </div>
                                <table>
                                    <tr
                                        v-for="key of Object.keys(headerTextMap)" 
                                        :key="item.rowid + key"
                                    >
                                        <td>{{ headerTextMap[key] + ':' }}</td>
                                        <td v-if="key === 'ticket'">
                                            <router-link
                                                :to="'/tickets/details?tid='+item.tid"
                    style="text-decoration: none;color: var(--ll-link)"
                                            >
                                                {{ item.ticket }}
                                            </router-link>                                        
                                        </td>
                                        <td v-else-if="key === 'member_codes'">
                                            <span v-if="item.member_codes.length">
                                                {{ item.member_codes[0] }}
                                            </span>
                                            <v-chip
                                                v-if="item.member_codes.length > 1"
                                                class="ma-0 pa-1"
                                                x-small
                                            >
                                                +{{ item.member_codes.length - 1 }}
                                            </v-chip>                                        
                                        </td>
                                        <td v-else>
                                            {{ formatMobileColumnValue(key, item[key]) }}
                                        </td>
                                    </tr>
                                </table>
                            </v-card>
                        </v-flex>
                    </template>
                </v-data-iterator>
                <v-toolbar
                    bottom
                    absolute
                    width="110%"
                >
                    <v-spacer />
                    <v-btn
                        width="240px"
                        elevation="0"
                        dark
                        color="#122448"
                        @click="dismissAllAlerts"
                    >
                        Dismiss All
                    </v-btn>
                    <v-spacer />
                </v-toolbar>
            </div>
            <v-col v-else>
                <v-card
                    flat
                    tile
                >
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="ticketAlerts"
                        item-key="name"                            
                    >
                        <template #item.alert_type="{ item }">
                            {{ formatAlertType(item.alert_type) }}
                        </template>
                        <template #item.alert_date="{ item }">
                            {{ formatAlertDate(item.alert_date) }}
                        </template>
                        <template #item.ticket="{ item }">
                            <router-link
                                :to="'/tickets/details?tid='+item.tid"
                            style="text-decoration: none; color: var(--ll-link)"
                            >
                                {{ item.ticket }}
                            </router-link>
                        </template>
                        <template #item.member_codes="{item}">
                            <span v-if="item.member_codes.length">
                                {{ item.member_codes[0] }}
                            </span>
                            <v-chip
                                v-if="item.member_codes.length > 1"
                                class="ma-0 pa-1"
                                x-small
                            >
                                +{{ item.member_codes.length - 1 }}
                            </v-chip>
                        </template>
                        <template #item.rowid="{ item }">
                            <v-icon
                                class="mr-2"
                                @click="dismissAlert(item.rowid)"
                            >
                                close
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row> 
        <v-row 
            v-else
            class="grow"
            align="center"
        >
            <v-col>
                <v-card 
                    align="center"
                    flat
                >
                    <v-img
                        width="90"
                        src="../../assets/no-alerts.png"
                    />
                    <v-card-subtitle>
                        There are no alerts
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';

const HEADER_TEXT_MAP = {
    alert_type: 'Type',
    alert_date: 'Alert Date',
    ticket: 'Ticket',
    county: 'County',
    place: 'Place',
    member_codes: 'Members',
    work_type: 'Work Type',
};

export default {
    name: 'TicketAlertsPage',
    data() {
        return {
            headerTextMap: HEADER_TEXT_MAP,
            headers: [
                {
                    text: HEADER_TEXT_MAP.alert_type,
                    align: 'start',
                    sortable: true,
                    value: 'alert_type',
                },
                {
                    text: HEADER_TEXT_MAP.alert_date,
                    sortable: true,
                    value: 'alert_date'
                },
                {
                    text: HEADER_TEXT_MAP.ticket,
                    sortable: true,
                    value: 'ticket'
                },
                {
                    text: HEADER_TEXT_MAP.county,
                    sortable: true,
                    value: 'county'
                },
                {
                    text: HEADER_TEXT_MAP.place,
                    sortable: true,
                    value: 'place'
                },
                {
                    text: HEADER_TEXT_MAP.member_codes,
                    sortable: true,
                    value: 'member_codes'
                },
                {
                    text: HEADER_TEXT_MAP.work_type,
                    sortable: true,
                    value: 'work_type'
                },
                {
                    text: 'Dismiss',
                    value: 'rowid',
                    sortable: false,
                    width: '48px',
                },                
            ],
        };
    },
    computed: {
        ticketAlerts() {
            return this.$store.getters.ticketAlerts;
        },
        alertsAudioOn() {
            return this.$store.getters.alertsAudioOn;
        }
    },
    created() {
        this.onDismissAlarm();
    },
    methods: {
        onDismissAlarm() {
            this.$store.commit('SET_ALERTS_AUDIO_ON', false);
        },
        formatMobileColumnValue(column, value) {
            switch(column) {
                case 'alert_type':
                    return this.formatAlertType(value);
                case 'alert_date':
                    return this.formatAlertDate(value);
                default:
                    return value;
            }
        },
        formatAlertType(alertType) {
            return alertType.replace('TICKET_ALERT_', '');
        },
        formatAlertDate(alertDate) {
            return moment(alertDate).format('MM/DD/YYYY hh:mm A');
        },
        changeAlertAudioOn(newValue) {
            this.$store.commit('SET_ALERTS_AUDIO_ON', newValue);
        },
        async dismissAlert(rowid) {
            await webtmsBackend.dismissTicketAlert(rowid);
            let ticketAlerts = await webtmsBackend.getTicketAlerts();
            this.$store.commit('SET_TICKET_ALERTS', ticketAlerts);
        },
        async dismissAllAlerts() {
            await webtmsBackend.dismissAllTicketAlerts();
            let ticketAlerts = await webtmsBackend.getTicketAlerts();
            this.$store.commit('SET_TICKET_ALERTS', ticketAlerts);
        }
    }
};
</script>
<style>
#ticket-alerts {
    height: 100%;
}
#top-alerts-toolbar {
    border-bottom: 2px solid #eee;
}
.moblie-alert-container {
    flex-basis: 0;
    flex-grow: 1;
}
.mobile-alert-card.theme--light.v-sheet {
    border-bottom: solid 1px #D4D7DE;
}
.mobile-alert-card table {
    margin: 16px;
}
.mobile-alert-card table tr td:first-child {
    width: 100px;
}
.mobile-alert-card table tr td:nth-child(2) {
    font-weight: 500;
}
.mobile-alert-dismiss-Icon {
    position: absolute;
    right: 0;
}
.moblie-alert-container .dissmiss-button-box {
    position: fixed;
    background-color: var(--ll-surface);
    height: 80px;
    flex-basis: 0;
    flex-grow: 1;
}
.v-data-table-header th {
  white-space: nowrap;
}
.member-code-count {
    background-color: var(--ll-surface-subtle);
}
#ticket-alerts .v-data-table {
    border: 1px solid var(--ll-border);
}
#ticket-alerts thead.v-data-table-header {
    background-color: var(--ll-surface-subtle);
    color: var(--ll-text-primary);
}
.v-toolbar .v-input.alarm-sound-switch {
    margin-top: 20px;
}
</style>
